<template>
  <div class="container trans scroll">
    <el-tree
      v-if="userInfo"
      ref="myTree"
      :data="userInfo && userInfo.menus ? userInfo.menus : []"
      :props="defaultProps"
      @node-click="handleClick"
      node-key="path"
      :highlight-current="false"
    >
      <div
        class="custom-tree-node el-tree-node__label flex-ac flex-start"
        slot-scope="{ node, data }"
      >
        <img
          :src="require('@/assets/images/icon/path_' + data.path + '.png')"
          class="icon_ path_icon"
        />
        <img
          :src="require('@/assets/images/icon/path_' + data.path + '_on.png')"
          class="icon_on path_icon"
        />
        <span
          >{{ node.label }}</span
        >
      </div>
    </el-tree>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["tabsList", "tabsOn", "userInfo"])
  },
  data() {
    return {
      data: [],
      defaultProps: {
        children: "children",
        label: "name"
      },
      currentNode: ""
    };
  },
  watch: {
    tabsOn(v) {
      if (v) this.$refs.myTree.setCurrentKey(v.path);
    }
  },
  mounted() {
    this.$bus.$on("leftRouter", it => {
      this.handleClick(it);
    });
  },
  methods: {
    handleClick(it) {
      if (!it) debugger;
      // console.log(it);
      if (!it.children || it.children.length == 0) {
        console.log("进入pages-  ", it.name, it.path);
        this.$refs.myTree.setCurrentKey(it.path);
        let list = JSON.parse(JSON.stringify(this.tabsList));
        let tabs = this.tabsList.filter(v => v.path == it.path);
        if (!list[0] || !tabs[0]) {
          list.push(it);
        }
        this.$store.dispatch("store/setTabsOn", it);
        this.$store.dispatch("store/setTabsList", list);
      } else {
        console.log("进入分类-  ", it.name, it.path);
      }
    }
  },
  destroyed() {
    this.$bus.$off("leftRouter");
  }
};
</script>
<style lang="stylus" scoped>
.container {
  height: calc(100vh - 50px);
  background: #fff;
  position: fixed;
  left: 0;
  top: 80px;
  width: 240px;
  padding: 0 10px;
  box-sizing: border-box;
}

.left {
  width: 200px;
  height: 100%;
}

>>>.el-tree-node__label {
  // font-family: 'font5' !important;
  font-weight: 500;
  text-indent: 0;
  color: rgba(79, 84, 112, 1);
}

>>>.el-tree-node.is-current > .el-tree-node__content {
  border-radius: 4px;
  background: rgba(234, 239, 255, 1);

  >>>.el-tree-node__expand-icon {
    color: rgb(0, 112, 255);
  }

  >>>.is-leaf {
    color: rgba(0, 0, 0, 0);
  }
}

.el-tree {
  background: transparent;
  color: rgba(32, 35, 50, 1);
}

>>>.el-tree-node__content:hover, >>>.el-upload-list__item:hover {
  background: rgba(245, 245, 245, 1);

  .el-tree-node__label {
    color: rgb(17, 130, 251) !important;
  }
}

>>>.el-tree-node__content {
  height: 40px;
}

.icon_ {
  display: block;
}

.icon_on {
  display: none;
}

.is-current .icon_ {
  display: none !important;
}

.is-current .icon_on {
  display: block !important;
}

.path_icon {
  width: 15px;
  height: 15px;
  margin-left: 15px;
}

>>>.is-focusable>.el-tree-node__content {
  height: 36px;
}

>>>.el-tree>.is-focusable {
  margin-bottom: 8px;
}

>>>.el-tree>.is-focusable>.el-tree-node__content {
  height: 48px;
}

>>>.el-tree-node.is-current>.el-tree-node__content {
  border-radius: 4px !important;
  background: rgba(234, 239, 255, 1) !important;
}

>>>.el-tree-node.is-current>.el-tree-node__content:before {
  content: '' !important;
  width: 4px !important;
  height: 16px !important;
  background: rgb(17, 130, 251) !important;
  top: 50% !important;
  left: 0 !important;
  transform: translate(0, -50%) !important;
  position: absolute !important;
  z-index: 1 !important;
}

>>>.el-tree-node.is-current .is-leaf {
  color: rgba(0, 0, 0, 0) !important;
}

>>>.el-tree {
  background: transparent !important;
  color: rgba(32, 35, 50, 1) !important;
}

>>>.el-tree-node__content:hover, >>>.el-upload-list__item:hover {
  background: transparent !important;
}

>>>.el-tree-node__content {
  height: 40px !important;
}

>>>.el-tree-node__expand-icon {
  position: absolute !important;
  top: calc(50% - 12px) !important;
  right: 5px !important;
  font-size: 16px !important;
}

>>>.el-tree-node__content {
  width: 100% !important;
  position: relative !important;
  box-sizing: border-box !important;
}

>>>.el-tree-node__label {
  text-indent: 1em !important;
}
</style>



// WEBPACK FOOTER //
// src/components/leftRouter.vue